export default __webpack_public_path__ + "static/carousel-hero-lite-2x-cab7dc114eca0d96e752928a9c5acfca.png";